import { Container, Row, Col } from "reactstrap";
import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import styles from "./styles.module.scss";

export const AccordionWithImage = ({
  className,
  title,
  heading,
  titleColour,
  content,
  image,
  items,
}) => {
  const [open, setOpen] = useState("");
  const toggle = (id) => setOpen(open === id ? "" : id);

  return (
    <section className={`${styles.accordion} ${className}`}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            {image?.url && (
              <img
                src={image.url}
                alt={image?.alt || ""}
                className="img-fluid"
                style={{ objectFit: "cover" }}
                data-sourceflow-prop="image"
              />
            )}
          </Col>
          <Col lg={6}>
            {title && (
              <h2
                className={`${heading} mb-5`}
                style={titleColour ? { color: titleColour } : null}
              >
                {title}
              </h2>
            )}
            {content && (
              <div
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            <Accordion open={open} toggle={toggle}>
              {items?.map((item, index) => (
                <AccordionItem key={index} className="mb-3 rounded-4 shadow-sm">
                  <AccordionHeader targetId={`${index}`} tag={item.tag ?? "h5"}>
                    <div data-sourceflow-prop={`items[${index}].title`}>
                      {item.title}
                    </div>
                  </AccordionHeader>
                  <AccordionBody accordionId={`${index}`}>
                    <div
                      data-sourceflow-prop={`items[${index}].content`}
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AccordionWithImage;
